"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _react = require("react");
var _safeConfig = require("../../packages/config/safe-config");
const useOAuthService = function () {
  const {
    REACT_APP_EOS_OAUTH_API_ENDPOINT
  } = (0, _safeConfig.useSafeConfigSlice)(["REACT_APP_EOS_OAUTH_API_ENDPOINT"]);
  const request = _axios.default.create();
  const findOAuthToken = (0, _react.useCallback)(async function (path) {
    const response = await request.post(REACT_APP_EOS_OAUTH_API_ENDPOINT, {
      resource: path
    });
    return response.data.body.data.AccessToken;
  }, [REACT_APP_EOS_OAUTH_API_ENDPOINT, request]);
  return {
    findOAuthToken
  };
};
var _default = exports.default = useOAuthService;